<template>
    <main>
        <div class="hero-mobile">
            <img class="bg-mobile" src="~@/assets/img/hero.jpg" alt="">
        </div>
        <div class="course-container tw-container">
            <div class="tw-text-center">
                <h1 class="">Encontre o Curso Ideal para si!</h1>
                <p class="">Temos Cursos de Formação em modelo <strong>Online, Híbrido</strong> e <strong>Presencial</strong>. Enquadramento Profissional em todas as Áreas e Estágio Incluído.</p>
            </div>
            <div class="input-group input-group-courses tw-px-4 lg:tw-px-12">
                <select
                    class="input-group-select"
                    v-if="$store.state.courseList !== []"
                    v-model="course"
                    @change="redirectToCourse"
                >
                    <option value="">Selecione um curso</option>
                    <option v-for="course in $store.state.courseList" :key="course.code" :value="slugifyCourse(course.humanFriendlyName)">{{ course.humanFriendlyName }}</option>
                </select>
            </div>
        </div>
    </main>
</template>
<script>

export default {
    data() {
        return {
            courseList: [],
            course: '',
        };
    },
    methods: {
        slugifyCourse(course) {
            return slugify(course);
        },
        redirectToCourse() {
            this.$router.push({ path: `/${(this.course).toLowerCase()}`, query: this.$route.query  });
        },
    },
    created() {
        axios
            .get('https://kw-lp-info.s3.eu-west-1.amazonaws.com/eFuturo/courses-list.json')
            .then((response) => {
                this.courseList = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    name: 'Home',
};
</script>
